import { useEntityItemsStore } from '@/stores/conduct/entityItems';
import * as TE from 'fp-ts/TaskEither';
import { pipe } from 'fp-ts/lib/function';
import { EntityItemList } from '@/entities/entityItem';
import { list } from '@/services/api/resources/entityItem';
import { EntityItemQuery } from '@/services/api/resources/entityItem/query';

export const retrieveEntityItems = (requestQuery: EntityItemQuery, bypassCache = false) => {
  const store = useEntityItemsStore();

  if (!bypassCache) {
    const item = store.getByQuery(requestQuery);

    if (item && item.entityItems) {
      return TE.right(item.entityItems as EntityItemList);
    }
  }

  return pipe(
    list(requestQuery),
    TE.map((result: EntityItemList) => {
      store.setEntityItems(requestQuery, result);

      return result;
    }),
  );
};
